import { ReactNode } from 'react';

import { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { isObservabilityEnabled } from '../../config';

const options: Partial<PostHogConfig> = {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  disable_session_recording: !isObservabilityEnabled(),
  capture_exceptions: isObservabilityEnabled(),
  capture_pageview: isObservabilityEnabled(),
  capture_performance: isObservabilityEnabled(),
  capture_dead_clicks: isObservabilityEnabled(),
  capture_heatmaps: isObservabilityEnabled(),
};

export const Provider = ({ children }: { children: ReactNode }) => (
  <PostHogProvider
    apiKey="phc_3bqxeGh0zSzpK28oVt9JY1MiwttlCJrng11m2rO7eJ5"
    options={options}
  >
    {children}
  </PostHogProvider>
);
